import axios from './configAxiosOrganizations';

export const getOrganizations = async (terminaId) => {
	return await axios.get(`/list/?terminal=${terminaId}&type=2&is_manager_confirmed=1`);
};
